import { render } from "./baseManage.vue?vue&type=template&id=684af82a&scoped=true&ts=true"
import script from "./baseManage.vue?vue&type=script&lang=ts"
export * from "./baseManage.vue?vue&type=script&lang=ts"

import "./baseManage.vue?vue&type=style&index=0&id=684af82a&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684af82a"]])

export default __exports__